import { render } from "./records.vue?vue&type=template&id=b5454530&scoped=true"
import script from "./records.vue?vue&type=script&lang=js"
export * from "./records.vue?vue&type=script&lang=js"

import "./records.vue?vue&type=style&index=0&id=b5454530&scoped=true&lang=css"
import "./records.vue?vue&type=style&index=1&id=b5454530&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5454530"]])

export default __exports__